import geoAPI from "../../../api/geoAPI";
import { urlContexts } from "../../../constants";

export const getFiles = async (id: any, tenantid: string) => {
  const { data } = await geoAPI.get(
        `${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
          (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
        }/iuvibanking-point-service-api/rest/1.0/process`,
        {
          headers: {
            tenant: tenantid
          },
          params: {
            appId: id
          }
        }
      );

  return data;
};

export const createFile = async (body: any, tenantid: string, appid: string) => {
  const { data } = await geoAPI.post(
        `${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
          (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
        }/iuvibanking-point-service-api/rest/1.0/process`,{
          ...body,
          appId: appid  
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            tenant: tenantid
          }
        }
      );

  return data;
};

export const updateFile = async (body: any, tenantid: string) => {
  const { data } = await geoAPI.put(
        `${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
          (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
        }/iuvibanking-point-service-api/rest/1.0/process/${body.id}`,{
          status: "CANCELED"
        },
        {
          headers: {
            tenant: tenantid
          }
        }
      );

  return data;
};

export const downloadFile = async (body: any, tenantid: string, appid: string) => {
  const { data } = await geoAPI.get(
        `${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
          (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
        }/iuvibanking-point-service-api/rest/1.0/download/service-point`,
        {
          headers: {
            tenant: tenantid
          },
          params: {
            appId: appid,
            countryId: body?.country,
            cityId: body?.city,
            scheduleTypeId: body?.typeOfSchedule,
            serviceId: body?.services,
            servicePointTypeId: body?.typeOfPointAttention,
          }
        }
      );

  if(data !== null) {
    let blob = new Blob([data], { type: 'text/csv' });
    let filename = "report.csv";
    let downloadLink = document.createElement("a");
    downloadLink.download = filename;
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }
  
  return data;
};

export const downloadTemplate = async () => {
  const { data } = await geoAPI.get(`${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
          (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
        }/files/template.csv`);

  return data;
};